export default __webpack_public_path__ + "static/media/icon-setting-blue.bdb22ecb.svg";